import axios from "axios";
import { authHeaders } from "./AuthState";
import { buildApiUrl } from "./Static";
import { normalizeLoginResponse } from "./loginAccount";

const isHtmlOrMissingRoute = (value) => {
  const text = String(value || "");
  return /<!DOCTYPE html/i.test(text) || /cannot post/i.test(text);
};

export default async function registerAccount({
  userName,
  email,
  password,
  brand = "",
  userType = "designer",
}) {
  const payload = {
    userName: String(userName || "").trim(),
    email: String(email || "").trim().toLowerCase(),
    password,
    brand: String(brand || "").trim().toLowerCase(),
    userType,
  };

  const { data: response } = await axios.post(
    buildApiUrl("/register"),
    payload,
    { headers: authHeaders() },
  );
  return normalizeLoginResponse(response) || response;
}

export const registerErrorMessage = (error) => {
  const status = error?.response?.status;
  const data = error?.response?.data;
  const serverMessage =
    (typeof data === "string" && data) ||
    data?.message ||
    data?.error ||
    data?.msg;

  if (status === 404 || isHtmlOrMissingRoute(serverMessage)) {
    return "Registration is not live on this API yet. Use the local API or deploy the new /register route.";
  }

  if (status === 409) {
    return typeof serverMessage === "string" && serverMessage.trim()
      ? serverMessage
      : "An account with this email already exists.";
  }

  if (status === 401) {
    return "Sign in again to create an account.";
  }

  if (status === 403) {
    return typeof serverMessage === "string" && serverMessage.trim()
      ? serverMessage
      : "Registration is not available for this account.";
  }

  if (status === 400) {
    return typeof serverMessage === "string" && serverMessage.trim()
      ? serverMessage
      : "Please check the registration details and try again.";
  }

  if (typeof serverMessage === "string" && serverMessage.trim()) {
    return serverMessage;
  }

  if (error?.message === "Network Error") {
    return "Unable to reach the registration service. The API endpoint may not be live yet.";
  }

  return "Unable to create this account. Please try again.";
};
